import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';

function SelectProcedureCode({
  rendercommonFormData,
  prefProc,
  patLabOrder,
  patientId,
  calback,
}) {
  const [procFrom, setProcFrom] = useState(
    parseInt(rendercommonFormData?.procedureForm) || 1
  );

  const [procCode, setProcCode] = useState(rendercommonFormData?.procedure_id);

  const handleProcData = (type) => {
    setProcFrom(type);
    setProcCode('');
    setPocSerVal('');
    setProcType(1);
    if (calback) calback(['', type, '', '', '', '', '', '']);
  };
  const [allData, setAllData] = useState([]);
  const [pocSerVal, setPocSerVal] = useState(
    rendercommonFormData?.procedure || ''
  );
  const [procType, setProcType] = useState(1);
  const [showProcDd, setShowProcDd] = useState(1);
  const [selected, setSelected] = useState(true);

  const handlePatProc = (e) => {
    setProcCode(e.target.value);
    if (calback) calback([e.target.value, procFrom, '', '', '', '', '', '']);
  };

  const handelProcSelect = (val, text, m1, m2, m3, m4, unit, ecid) => {
    setProcCode(val);
    setShowProcDd(false);
    setPocSerVal(text);
    setSelected(false);
    if (calback) calback([val, procFrom, m1, m2, m3, m4, unit, ecid]);
  };

  const handleProcType = (e) => {
    setProcType(e.target.value);
    setProcCode(0);
    setPocSerVal('');
  };

  useEffect(() => {
    setSelected(true);
    if (pocSerVal.length >= 3 && selected) {
      (async () => {
        try {
          const response = await post(
            'api/patient/progressNote/getProcedureListForDropdown',
            {
              term: pocSerVal,
              searchCodeType: procType,
              patientId: patientId,
              searchMode: 'counselling',
            }
          );
          if (response.status === 200) {
            setShowProcDd(true);
            setAllData(response?.data);
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      })();
    } else {
      //setUiMessage('inf', 'Plese type atleast 3 charactors.');
      setShowProcDd(false);
      setAllData([]);
    }
  }, [patientId, pocSerVal, procType, selected]);

  return (
    <>
      <span className="pop-up-sb-hdr">Select Procedure Code</span>
      <div className="appt-hx-fa-rw">
        <input
          type="radio"
          name="prefType"
          className="clear-right10"
          checked={procFrom === 1}
          onChange={() => handleProcData(1)}
          disabled={rendercommonFormData?.serviceFlag === '1' ? true : false}
        />
        Patient
        <input
          type="radio"
          name="prefType"
          className="clear-right10 clear-left10"
          checked={procFrom === 2}
          onChange={() => handleProcData(2)}
          disabled={rendercommonFormData?.serviceFlag === '1' ? true : false}
        />
        Preferred
        <input
          type="radio"
          name="prefType"
          className="clear-right10 clear-left10"
          checked={procFrom === 3}
          onChange={() => handleProcData(3)}
          disabled={rendercommonFormData?.serviceFlag === '1' ? true : false}
        />
        Master
      </div>
      <div className="appt-hx-fa-rw">
        {(procFrom === 1 && (
          <span className="width100">
            <select
              className="cpt-dd"
              value={procCode}
              onChange={handlePatProc}
            >
              <option value="">{''}</option>
              {patLabOrder?.map((data, i) => (
                <option key={i} value={data.id}>
                  {data?.orderName}
                </option>
              ))}
            </select>
          </span>
        )) ||
          (procFrom === 2 && (
            <span className="width100">
              <select
                className="cpt-dd"
                value={procCode}
                onChange={handlePatProc}
              >
                <option value="">{''}</option>
                {prefProc?.map((data, i) => (
                  <option key={i} value={data.id}>
                    {data?.orderName}
                  </option>
                ))}
              </select>
            </span>
          )) ||
          (procFrom === 3 && (
            <span className="width100">
              <div style={{ position: 'relative' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <select
                    value={procType}
                    onChange={handleProcType}
                    className="book-appt-dd"
                    style={{ width: '35%', marginRight: '10px' }}
                    disabled={
                      rendercommonFormData?.serviceFlag === '1' ? true : false
                    }
                  >
                    <option value={1}>CPT/HCPCS</option>
                    <option value={2}>SNOMED</option>
                    <option value={3}>LOINC</option>
                  </select>
                  <input
                    type="serch"
                    value={pocSerVal}
                    onChange={(e) => setPocSerVal(e.target.value)}
                    className="cpt-master-search"
                    style={{ width: '58%', borderRadius: '5px' }}
                    disabled={
                      rendercommonFormData?.serviceFlag === '1' ? true : false
                    }
                  />
                </div>
                {allData.length > 0 && showProcDd && (
                  <div className="proc-list-dd">
                    {allData &&
                      allData.map((item, i) => (
                        <div
                          key={i}
                          style={{
                            padding: '10px',
                            borderBottom: '1px solid #ccc',
                          }}
                          onClick={() =>
                            handelProcSelect(
                              item?.id,
                              item?.name,
                              item?.modifier1,
                              item?.modifier2,
                              item?.modifier3,
                              item?.modifier4,
                              item?.unit,
                              item?.evaluateCodeId
                            )
                          }
                        >
                          {item.name}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </span>
          ))}
      </div>
    </>
  );
}

export default SelectProcedureCode;
